import { buildEnrollmentDraftSnapshot, readEnrollmentDraftFieldValue } from './enrollmentDraftSnapshot'
import {
  hasRecentDraftApplicationData,
  readStoreDraftFormData
} from './enrollmentDraftReaders'
import type { EnrollmentDraftStorageKey } from './enrollmentDraftKeys'
import type { EnrollmentDraftData, StoredEnrollmentFormRecord } from './enrollmentDraftSnapshot'

export const readEnrollmentStoredFormData = (): StoredEnrollmentFormRecord => {
  return {}
}

export const hasRecentApplicationData = () => hasRecentDraftApplicationData()

export const readEnrollmentDraftSnapshot = (): EnrollmentDraftData => {
  const storeFormData = readStoreDraftFormData()
  return buildEnrollmentDraftSnapshot(storeFormData, readEnrollmentStoredFormData())
}

export const readEnrollmentDraftValue = (key: EnrollmentDraftStorageKey) => {
  const formData = readStoreDraftFormData()
  const stored = readEnrollmentStoredFormData()
  return readEnrollmentDraftFieldValue(formData, stored, key)
}
